import React from 'react';
import classNames from 'classnames';
import { Image } from '$components/basic/Image';
import { Card } from './styled';

export interface IProps {
  readonly title: string;
  readonly className?: string;
  readonly imgSrc: string;
  readonly children: React.ReactNode;
}

function StepCard({ title, className, imgSrc, children, ...props }: IProps) {
  return (
    <Card {...props} className={classNames('StepCard', className)}>
      <div className="left">
        <Image
          provider="cloudinary"
          src={imgSrc}
          alt={title}
          layout="responsive"
          width="470"
          height="200"
          objectFit="cover"
        />
      </div>

      <div className="right">
        <div className="title">{title}</div>
        <div className="content">{children}</div>
      </div>
    </Card>
  );
}

export default StepCard;
